import React from "react";
import { useSelector } from "react-redux";

import { Container } from "@gamedev-web/gamedev-sdk-core";

import {
  AskTheExpertsUrl,
  AzureCreditsFaqUrl,
  DevHubUrl,
  EdsUrl,
  EducationPortalUrl,
  GameDevelopmentUrl,
  GdkDocumentsUrl,
  GdkDownloadUrl,
  IdAzureProgramDetailsUrl,
  LatestGdkReleaseUrl,
  partnerCenterUrl,
  PlayfabFaqUrl,
  XboxDevForumsUrl,
  XboxGdkSamplesUrl,
  XboxPublisherGuideUrl,
  XdkDownloadUrl,
  XgdUrl,
} from "../../constants";
import { useStrings } from "../../localization/localizationHelpers";
import { Programs } from "../../models/programsConfig";
import { getIsAtLeastOneSignedGdkContract } from "../../redux/selectors";
import { DevResource, DevResourceItem } from "../DevResource";
import { RightPaneBox } from "../RightPaneBox";
import * as styles from "./DevResourcesList.module.css";

interface DevResourcesListProps {
  program: Programs;
}

export const DevResourcesList = ({ program }: DevResourcesListProps) => {
  const [
    developerResources,
    developerResourcesDescription,
    gameDevelopment,
    gdkDocuments,
    xboxGdkSamples,
    latestGdkRelease,
    xboxDevForums,
    gdkDownload,
    xboxPublisherGuide,
    xdkDownload,
    eds,
    joinTheDevHubDevResource,
    programDetailsDevResource,
    azureCreditsFaqDevResource,
    playfabFaqDevResource,
    educationPortalDevResource,
    askTheExpertsDevResource,
    partnerCenter,
  ] = useStrings(
    "developerResources",
    "developerResourcesDescription",
    "gameDevelopment",
    "gdkDocuments",
    "xboxGdkSamples",
    "latestGdkRelease",
    "xboxDevForums",
    "gdkDownload",
    "xboxPublisherGuide",
    "xdkDownload",
    "eds",
    "joinTheDevHubDevResource",
    "programDetailsDevResource",
    "azureCreditsFaqDevResource",
    "playfabFaqDevResource",
    "educationPortalDevResource",
    "askTheExpertsDevResource",
    "partnerCenter"
  );
  const contractsSigned = useSelector(getIsAtLeastOneSignedGdkContract);
  const idXboxPublicLinks: DevResourceItem[] = [
    {
      title: gameDevelopment,
      url: GameDevelopmentUrl,
    },
    {
      title: gdkDocuments,
      url: GdkDocumentsUrl,
    },
    {
      title: xboxGdkSamples,
      url: XboxGdkSamplesUrl,
    },
    {
      title: latestGdkRelease,
      url: LatestGdkReleaseUrl,
    },
  ];
  const idXboxContractSignedLinks: DevResourceItem[] = [
    {
      title: xboxDevForums,
      url: XboxDevForumsUrl,
    },
    {
      title: "XGD",
      url: XgdUrl,
    },
    {
      title: gdkDownload,
      url: GdkDownloadUrl,
    },
    {
      title: xboxPublisherGuide,
      url: XboxPublisherGuideUrl,
    },
    {
      title: xdkDownload,
      url: XdkDownloadUrl,
    },
    {
      title: eds,
      url: EdsUrl,
    },
  ];
  const idAzureLinks: DevResourceItem[] = [
    {
      title: joinTheDevHubDevResource,
      url: DevHubUrl,
    },
    {
      title: programDetailsDevResource,
      url: IdAzureProgramDetailsUrl,
    },
    {
      title: azureCreditsFaqDevResource,
      url: AzureCreditsFaqUrl,
    },
    {
      title: playfabFaqDevResource,
      url: PlayfabFaqUrl,
    },
    {
      title: educationPortalDevResource,
      url: EducationPortalUrl,
    },
    {
      title: askTheExpertsDevResource,
      url: AskTheExpertsUrl,
    },
  ];
  const aaaLinks: DevResourceItem[] = [
    {
      title: xboxPublisherGuide,
      url: XboxPublisherGuideUrl,
    },
    {
      title: partnerCenter,
      url: partnerCenterUrl,
    },
    {
      title: eds,
      url: EdsUrl,
    },
    {
      title: xboxDevForums,
      url: XboxDevForumsUrl,
    },
    {
      title: gameDevelopment,
      url: GameDevelopmentUrl,
    },
    {
      title: gdkDocuments,
      url: GdkDocumentsUrl,
    },
    {
      title: xboxGdkSamples,
      url: XboxGdkSamplesUrl,
    },
    {
      title: latestGdkRelease,
      url: LatestGdkReleaseUrl,
    },
    {
      title: "XGD",
      url: XgdUrl,
    },
    {
      title: gdkDownload,
      url: GdkDownloadUrl,
    },
    {
      title: xdkDownload,
      url: XdkDownloadUrl,
    },
  ];

  let links: DevResourceItem[] = [];
  switch (program) {
    case Programs.IdXbox:
      links = idXboxPublicLinks;
      if (contractsSigned) {
        links = [...links, ...idXboxContractSignedLinks];
      }
      break;

    case Programs.IdAzure:
      links = idAzureLinks;
      break;

    case Programs.Aaa:
      links = aaaLinks;
      break;

    default:
      links = [];
      break;
  }

  return (
    <RightPaneBox customClassName={styles.welcomePartnerPane}>
      <Container className={styles.listContainer}>
        <h2 className={styles.title}>{developerResources}</h2>
        <p className={styles.description}>{developerResourcesDescription}</p>
        {links.map((item: DevResourceItem, index: number) => (
          <DevResource key={index} item={item} />
        ))}
      </Container>
    </RightPaneBox>
  );
};
